import { Box, styled } from '@mui/joy';

export const dropzoneStyle = {
  width: '50%',
  height: '20%',
  minWidth: '200px',
  minHeight: '120px',
};

export const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});
